import { AttributesMixin, define, Model } from '@type-r/models';
import { type } from '@type-r/models/lib/model';
import { fetchJson } from 'api/endpoint';

const rootPendingActions = '/api/v2/invoices/pending-actions';
const rootNotSent = '/api/v2/invoices/pending-actions/not-sent/';

export const flagAsReady = (state) =>
    state.isReady = true;
export const fetchAndResolve = (state) => {
    state.isReady = false;
    return state.fetch()
        .then(() => flagAsReady(state))
        .catch(() => flagAsReady(state));
}

export type InvoiceItemAction = 'out-of-inb' | 'waiting-confirmation' | 'mark-as-sent' | 'mark-as-confirmed' | 'mark-as-sent-confirmed';

export const TimeRangeTypes = [
    { label: 'Daily', val: 0 },
    { label: 'Weekly', val: 7 },
    { label: 'Monthly', val: 30 },
    { label: 'Last 90 Days', val: 90 }
];

@define export class InvoiceItem extends Model {
    static attributes = {
        invoiceNumber: String,
        outstandingInvoiceAmount: Number,
        invoiceDueDate: Date,
        currency: String
    }

    static async fetchInvoiceItems(action: InvoiceItemAction, relationshipId) {
        const url = rootNotSent + action + `?relationshipId=${relationshipId}`;
        return await fetchJson('GET', url);
    }
    static async executeAction(action: InvoiceItemAction, payload) {
        const url = rootNotSent + action;
        return await fetchJson('POST', url, payload);
    }
}
export interface InvoiceItem extends AttributesMixin<typeof InvoiceItem> { }

@define
export class PendingActionsInvoices extends Model {
    static attributes = {
        relationshipId: Number,
        customerName: String,
        customerExternalId: String,
        count: Number,
        outstandingAmountSum: Number,
        lastSoaSentDate: type(Date).null
    };

    static async fetchOverdueInvoices() {
        const url = `${rootPendingActions}/overdue/`;
        return await fetchJson('GET', url);
    }

    static async fetchDisputedInvoices() {
        const url = `${rootPendingActions}/dspt/`;
        return await fetchJson('GET', url);
    }

    static async fetchBrokenPromiseInvoices() {
        const url = `${rootPendingActions}/broken-promise/`;
        return await fetchJson('GET', url);
    }

    static async fetchUpcomingInvoices() {
        const url = `${rootPendingActions}/upcoming/`;
        return await fetchJson('GET', url);
    }

    static async fetchSentOutInvoices(timeRangeValue) {
        const url = `/api/v2/invoice-management/landing/review-items/invoices-sent/${timeRangeValue}/`;
        return await fetchJson('GET', url);
    }

    static async fetchApprovedInvoices(timeRangeValue) {
        const url = `/api/v2/invoice-management/landing/review-items/approved-invoices/${timeRangeValue}/`;
        return await fetchJson('GET', url);
    }
}
export interface PendingActionsInvoices extends AttributesMixin<typeof PendingActionsInvoices> { }
